import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import global from '@/utils/global'
import comm from '@/utils/comm.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "@/assets/css/iconfont/iconfont.css"
import ajax from './api/https'
import api from './api/api'
import QS from 'qs'
import VueCropper from 'vue-cropper'
import i18n from './lang' // 语言国际化方案

Vue.prototype.$ajax = ajax;
Vue.prototype.$api = api;
Vue.prototype.$qs = QS;
Vue.prototype.$comm = comm;
Vue.prototype.$global = global;

Vue.use(VueCropper)
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});

//跳转
router.beforeEach((to, from, next) => {
	let token = localStorage.getItem('newsWebToken');
	//判断该路由是否需要登录权限
	if(to.meta.requireAuth){
		if(token){                                     //看token是否存在
			next();
		}
		else{
            next({
                path: "/login",
                query: {
                    "redirect": encodeURI(to)
                }
            });
		}
	}
	else{
		next();
	}
})



// WEBPACK FOOTER //
// ./src/main.js